import ConfirmPage from './ConfirmPage';

export default ConfirmPage;
